<form [formGroup]=form>
	<h4 class="bk-modal__section-title">
		{{'Calculate Drip Application Rate' | translate }}
	</h4>
	<label class="bk-modal__label">
		{{'Bed Width' | translate}}
	</label>

	<input class="bk-modal__field--with-unit bk-input--short
		bk-modal__field"
		type="number"
		required
		formControlName="BedWidth" />

	<div class="bk-modal__field-unit">
		{{'in' | translate}}
	</div>

	<mat-error *ngIf="f.BedWidth.invalid && (f.BedWidth.dirty
		|| f.BedWidth.touched)">
		<span *ngIf="f.BedWidth.errors.valueNotAnInteger"
			class="bk-clearfix cm-error-warning">
			{{ "You must enter an integer in this field" | translate }}.
		</span>
	</mat-error>

	<label class="bk-modal__label">
		{{'Number of drip lines per bed' | translate}}
	</label>

	<input class="bk-input--short bk-modal__field"
		type="number"
		required
		formControlName="DripLinesPerBed" />

	<mat-error *ngIf="f.DripLinesPerBed.invalid && (f.DripLinesPerBed.dirty
		|| f.DripLinesPerBed.touched)">
		<span *ngIf="f.DripLinesPerBed.errors.valueNotAnInteger"
		class="cm-error-warning">
			{{ "You must enter an integer in this field" | translate }}.
		</span>
	</mat-error>
	
	<label class="bk-modal__label">
		{{'Tape Discharge Rate' | translate}}
	</label>

	<input class="bk-modal__field--with-unit bk-input--short bk-modal__field"
		type="number"
		step="0.01"
		required
		formControlName="TapeDischargeRate" />

	<div class="bk-modal__field-unit">
		{{'gpm' | translate}}/100 {{'ft' | translate}}
	</div>

	<div class="bk-modal__section-buttons">
		<button class="bk-button bk-button--medium bk-button--text-only"
			(click)="cancel($event)">
			{{'Cancel' | translate }}
		</button>
		<button class="bk-button bk-button--medium"
			[disabled]="form.invalid"
			(click)="calculate($event)">
			{{'Calculate' | translate }}
		</button>
	</div>
</form>